import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { EnhancedFABComponent } from './enhanced-fab.component';
import { FABActionDefinitionsService } from './services/fab-action-definitions.service';
import { FABIntegrationService } from './services/fab-integration.service';

@NgModule({
  declarations: [
    EnhancedFABComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    EnhancedFABComponent
  ],
  providers: [
    FABActionDefinitionsService,
    FABIntegrationService
  ]
})
export class FABModule { }